import React, { useState } from "react";

const Search = ({ initialTerm = "", onSubmit }) => {
  const [characterName, setCharacterName] = useState(initialTerm);

  function handleChange(e) {
    setCharacterName(e.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit(characterName);
  }

  return (
    <form onSubmit={handleSubmit}>
      <label htmlFor="characterName-input">Character Name</label>
      <div>
        <input
          id="characterName-input"
          name="characterName"
          placeholder="Character Name..."
          value={characterName}
          onChange={handleChange}
        />
        <button type="submit" disabled={!characterName.length}>
          Submit
        </button>
      </div>
    </form>
  );
};

export default Search;
